import dark from './roma'
import light from './shine'

export default {
  dark,
  light,
}
